// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-452f577e]{border-collapse:collapse}table[data-v-452f577e],td[data-v-452f577e],th[data-v-452f577e]{border:.5px solid #000}thead[data-v-452f577e]{display:table-row-group}tr td[data-v-452f577e]{page-break-inside:avoid}.no-border[data-v-452f577e]{border:none!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
